import {LanguageModel} from '../../translation/translation.models';
import {Country} from '../../shared/Models/Country';
import {SystemUser} from '../../shared/Models/SystemUser';
import {UserTerm} from './UserTerm';
import {CollectionDiscount} from './CollectionDiscount';
import {CollectionTransportationCost} from './CollectionTransportationCost';

export class InvoiceDealer {
  static INVOICEDEALER_ACTIVE = 'active';
  static INVOICEDEALER_ON_HOLD = 'on_hold';
  static INVOICEDEALER_INACTIVE = 'inactive';

  static INVOICEDEALER_paymentCondition_14DAYS = '14days';
  static INVOICEDEALER_paymentCondition_21DAYS = '21days';
  static INVOICEDEALER_paymentCondition_30DAYS = '30days';
  static INVOICEDEALER_paymentCondition_BEFORE_PRODUCTION = 'before_production';
  static INVOICEDEALER_paymentCondition_BEFORE_DELIVERY = 'before_delivery';


  public id: number;
  public companyName: string;
  public address: string;
  public zipCode: string;
  public city: string;
  public email: string;
  public phone: string;
  public website: string;
  public cocNumber: string;
  public vatNumber: string;
  public paymentCondition: string;
  public bicSwift: string;
  public iban: string;
  public firstName: string;
  public surname: string;
  public contact?: string;
  public contactEmail: string;
  public contactPhone: string;
  public status: string;
  public termStatus?: string;
  public bundleInvoices?: boolean;
  public isCustomerAccount?: boolean;
  public language?: number | LanguageModel;
  public country?: Country;
  public users?: SystemUser[];
  public debtor: string;
  public userTerms: UserTerm[];
  public collectionDiscounts?: CollectionDiscount[];
  public collectionTransportationCosts?: CollectionTransportationCost[];
  public transportationCostDescription?: string;
  public salesVatCode?: string;
  public salesVatPercentage?: number;
}
